<template>
    <div>
        <loader :show="enviando"/>
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 md12>
                    <v-card class="elevation-10">
                        <v-toolbar >
                            <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                            <v-card-title><h3>Licencias</h3></v-card-title>
                        </v-toolbar>

                        <v-card-text>

                            <busqueda 
                                :empleados="empleadoSel"
                                @buscarEmpleado="buscarEmpleado"
                                @buscarRango="buscarRango"
                            />
                        </v-card-text>

                        <v-card-text>
                            <v-layout align-center justify-end row fill-height>
                                <v-flex xs12 sm7 md6 lg6>
                                    <v-text-field
                                        v-model="buscar"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-data-table
                                :headers="lista.headers"
                                :items="lista.data"
                                :rows-per-page-items="tableProps.rows"
                                :no-data-text="tableProps.noData"
                                :no-results-text="tableProps.noResults"
                                :rows-per-page-text="tableProps.rowsText"
                                class="elevation-1"
                                :search="buscar"
                            >
                                <template slot="items" slot-scope="props">
                                    <td>
                                        <v-menu v-if="puedeModificar || puedeEliminar"
                                            transition="scale-transition"
                                            origin="left top"
                                            bottom
                                            right
                                            slot="activator"
                                        >
                                            <v-btn class="ma-0" icon slot="activator">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                            <v-list class="app-card-action">
                                                <v-list-tile v-if="puedeModificar" 
                                                        @click="modificaDialog(props.item._id,props.item.observaciones)">
                                                    <i class="fa fa-edit blue--text mr-2 fs-14"></i>
                                                    <span>Observaciones</span>
                                                </v-list-tile>
                                                <v-list-tile v-if="puedeEliminar" @click="eliminaFecha(props.item._id)">
                                                    <i class="fa fa-times red--text mr-2 fs-14"></i>
                                                    <span>Eliminar</span>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>

                                    </td>
                                    <td class="text-xs-left">{{ props.item.dia }}</td>
                                    <td class="text-xs-left">{{ props.item.mes }}</td>
                                    <td class="text-xs-left">{{ props.item.anio }}</td>
                                    
                                    <td class="text-xs-left">{{ props.item.observaciones }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>


                        <v-card-text v-if="puedeAgregar">
                            <agregar 
                                :empleados="empleadoSel"
                                @enviandoStart="enviando=true"
                                @enviandoStop="enviando=false"
                            />
                        </v-card-text>


                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog v-model="modificar.mostrar" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">Observaciones</v-card-title>
                <v-card-text>
                    <v-textarea
                        label="Observaciones"
                        v-model="modificar.texto"
                        rows="5"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="normal" @click="modificar.mostrar = false">Cancelar</v-btn>
                <v-btn color="primary" @click="modificarObs()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import Busqueda from './busqueda'
import Agregar from './agregar'
import axios from 'axios'
import _ from 'underscore'
import moment from 'moment'
moment.locale('es')

export default {
    name: 'Licencias',
	components: {
        Loader,
        Busqueda,
        Agregar
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "permisos",
            "role"
        ]),
        puedeAgregar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 205) >= 0 ? true : false;
        },
        puedeModificar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 206) >= 0 ? true : false;
        },
        puedeEliminar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 207) >= 0 ? true : false;
        },
        fechaAgregar(){
            return this.agregar.fecha ? moment(this.agregar.fecha).format('DD [de] MMMM [de] YYYY') : ''
        }
    },
    data() {
        return {
            enviando:false,
            empleado: null,
            empleadoSel: [],
            buscar:'',
			lista:{
				headers:[
                    { text: '', value: 'options', sortable: false },
                    { text: 'Día', value: 'dia' },
                    { text: 'Mes', value: 'mes' },
                    { text: 'Año', value: 'anio' },
                    { text: 'Observaciones', value: 'observaciones' },
                ],
                data:[]
            },
            modificar:{
                mostrar: false,
                id:null,
                texto: null
            }
        }
    },
    created(){
        this.enviando = true;
        axios.get(this.httpURL+'/licencias/usuarios',{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res);
                res.data.usuarios.forEach(element => {
                    this.empleadoSel.push({
                        value: element._id,
                        text: element.codigo+' - '+element.paterno+' '+element.materno+' '+element.nombre
                    });
                });
                this.enviando = false
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    methods:{
        allowedDates(fecha){
            let licencias = [];
            let found = false;
            // console.log(fecha);
            this.lista.data.forEach(element => {
                if(element.fecha == fecha)
                    found = true;
            });
            return !found;
        },
        buscarEmpleado(id){
            this.enviando = true;
            axios.get(this.httpURL+'/licencias/usuario/'+id,{headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    this.lista.data = [];
                    res.data.licencias.forEach(element => {
                        this.lista.data.push({
                            _id: element._id,
                            dia: moment(element.fecha).format('DD'),
                            mes: moment(element.fecha).format('MMMM'),
                            anio: moment(element.fecha).format('YYYY'),
                            observaciones: element.observaciones,
                            fecha: moment(element.fecha).format('YYYY-MM-DD')
                        });
                    });
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        buscarRango(inicio,fin){
            this.enviando = true;
            axios.get(this.httpURL+'/licencias/rango/'+inicio+'/'+fin,{headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    this.lista.data = [];
                    res.data.licencias.forEach(element => {
                        this.lista.data.push({
                            _id: element._id,
                            dia: moment(element.fecha).format('DD'),
                            mes: moment(element.fecha).format('MMMM'),
                            anio: moment(element.fecha).format('YYYY'),
                            observaciones: element.observaciones,
                            fecha: moment(element.fecha).format('YYYY-MM-DD')
                        });
                    });
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        modificaDialog(id,texto){
            this.modificar.id = id;
            this.modificar.texto = texto;
            this.modificar.mostrar = true;
        },
        modificarObs(){
            this.enviando = true;
            axios.put(this.httpURL+'/licencias/observaciones/'+this.modificar.id,
                {observaciones: this.modificar.texto},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res);
                    this.modificar.mostrar = false;
                    let index = this.lista.data.findIndex(x=>x._id == this.modificar.id);
                    this.lista.data[index].observaciones = this.modificar.texto;
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        eliminaFecha(id){
            this.enviando = true;
            axios.delete(this.httpURL+'/licencias/fecha/'+id,
                { headers:{token: this.sessionToken} })
                .then(res => {
                    // console.log(res);
                    let index = this.lista.data.findIndex(x=>x._id == id);
                    this.lista.data.splice(index,1);
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviando = false;
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>